import React, { FC, useId, useMemo } from 'react'

import { textToHtmlElements } from 'pages/frequent-questions/utils/replace-link-tags'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'

import { Text } from '@interco/inter-ui/components/Text'

import { ArticleContainer, HtmlContainer } from './styles'
import { LinkParagraph } from '../link-paragraph'

type ArticleProps = {
  htmlText: string
  isError: boolean
}

export const Article: FC<ArticleProps> = ({ htmlText, isError }) => {
  const { userLanguage } = useAppContext()

  const id = useId()

  const answer = useMemo(() => {
    if (isError) {
      if (userLanguage === 'en-US') return 'Oops, something went wrong.'
      if (userLanguage === 'es-ES') return 'Vaya, algo salió mal.'
      return 'Ops, algo deu errado.'
    }

    if (!htmlText) return ''

    const paragraphs = htmlText.split('\n').map((paragraph, index) => {
      const key = `${id}-${index}`
      const paragraphContent = textToHtmlElements(paragraph)

      if (paragraphContent.html)
        return (
          <HtmlContainer key={key} dangerouslySetInnerHTML={{ __html: paragraphContent.html }} />
        )

      if (paragraphContent.link.href) {
        return <LinkParagraph key={key} {...paragraphContent} />
      }

      if (paragraphContent.text)
        return (
          <Text key={key} variant="body-3">
            {paragraphContent.text}
          </Text>
        )

      return null
    })

    return paragraphs
  }, [htmlText, id, isError, userLanguage])

  return <ArticleContainer>{answer}</ArticleContainer>
}
